import "./MyCollectionPage.scss";

import MyCollectionPage from "./MyCollectionPage";

export default MyCollectionPage;
